import React from "react";
import VariableSizeInfiniteChatList from "../../../messages/bubbles/VariableSizeInfiniteChatList";
import useReportMessages from "../hooks/useReportMessages";

const ReportMessagesList = ({ masterAccountId, reportId }) => {
    const { 
        clear: refreshTable,
        data,
        error,
        isLoading,
        isNextPageLoading,
        isRowLoaded,
        loadMore,
        totalCount
    } = useReportMessages(masterAccountId, reportId);

    return (
        <React.Fragment>
            <VariableSizeInfiniteChatList 
                error={error}
                retry={refreshTable}
                itemCount={totalCount}
                itemData={data}
                loadMoreItems={loadMore}
                isLoading={isLoading}
                isFetching={isNextPageLoading}
                hasItemLoaded={isRowLoaded}
            />
        </React.Fragment>
    );
};

export default ReportMessagesList;